'use strict';

angular.module('imagetrend.components')
    .directive('ckEditor', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            require: '?ngModel',
            scope: {
                height: '@?',
                toolbarGroups: '=?',
                skin: '=?',
                remove: '=?'
            },
            link: function (scope, elm, attr, ngModel) {
                if (!ngModel) return;
                if (!scope.height) {
                    scope.height = 250;
                }
                if (!scope.toolbarGroups) {
                    scope.toolbarGroups = [
                        { name: 'clipboard', groups: ['clipboard', 'undo'] },
                        { name: 'links' },
                        { name: 'insert', groups: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
                        { name: 'tools', groups: ['Maximize'] },
                        { name: 'others' },
                        '/',
                        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                        { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
                        { name: 'styles' },
                        { name: 'colors' },
                        { name: 'about' }
                    ];
                }

                // Set Skin
                if (!scope.skin && scope.$root.$state.current.name === "portal.menus.login") {
                    scope.skin = 'bootstrapck';
                }
                else if (!scope.skin || scope.skin == '')
                {
                    scope.skin = 'moono';
                }

                // Remove any plugins (mostly toolbar things)
                if (!scope.remove || scope.remove == '')
                {
                    scope.remove = 'liststyle,exportpdf,smiley,iframe,showblocks,copyformatting';
                }
                else
                {
                    scope.remove += 'liststyle,exportpdf,smiley,iframe,showblocks,copyformatting';
                }

                var ck = CKEDITOR.replace(elm[0], {
                    toolbar: 'Regular',
                    forcePasteAsPlainText: 'true',
                    height: scope.height,
                    toolbarGroups: scope.toolbarGroups,
                    skin: scope.skin,
                    removePlugins: scope.remove
                });

                ck.on('instanceReady', function () {
                    ck.setData(ngModel.$viewValue);
                });

                ck.on('change', function () {
                    var timer = $timeout(function() {
                        ngModel.$setViewValue(ck.getData());
                    }, 0);
                    scope.$on('$destroy', function () {
                        $timeout.cancel(timer);
                    });
                });

                ngModel.$render = function (value) {
                    ck.setData(ngModel.$viewValue);
                };

                elm.bind('$destroy', function () {
                    ck.destroy();
                });
            }
        }
    }])
    .directive('ckHtml', ['$sce', function ($sce) {
        return {
            restrict: 'E',
            scope: {
                htmlSrc: '@?',
                id: '@?'
            },
            transclude: true,
            template:
                '<div id="{{id}}" class="wrap keep-styling" ng-bind-html="newHtml"></div>',
            link: function (scope, elm, attr) {
                attr.$observe("htmlSrc", function () {
                    scope.newHtml = $sce.trustAsHtml(scope.htmlSrc);
                });
            }
        }
    }])
;